import React from 'react';
import './Panel.scss';

export default class Panel extends React.Component {


  getRootClass(){
    return 'box-panel ComponentPanel ' + (this.props.className || '');
  }

  renderFooter(){
    if(this.props.footer){
      return (
          <div className="box-panel--footer">
            {this.props.footer}
          </div>
      )
    }
    return null;
  }

  render() {
    return (
        <div className={this.getRootClass()}>
          <div className="box-panel--head d-flex align-items-center">
            <div className="title">
              <h2>{this.props.title}</h2>
            </div>
            {
              this.props.controls ? [
                <div style={{flexGrow: '10'}} key="divider"></div>,
                <div key="controls">{this.props.controls}</div>
              ] : null
            }
          </div>
          <div className="box-panel--content">
            {this.props.children}
            {this.renderFooter()}
          </div>
        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Panel.js